import React from "react";
import MovieDetail from "./MovieDetail";
import { useSelector } from "react-redux";

const SearchResults = () => {
  const movies = useSelector((state) => state.searchResults);

  return (
    <div className="max-h-[480px] divide-y divide-slate-400 overflow-y-scroll lg:max-h-[500px]">
      {movies &&
        movies.map((movie) => {
          return <MovieDetail key={movie.id} movie={movie} />;
        })}
    </div>
  );
};

export default SearchResults;
